module.exports = require('./helpers/bundle-url').getBundleURL('hcuA3') + "logo.c5857b8b.svg";